var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"BaseButtonContents"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.loading)?_c('BaseLoader',{attrs:{"color":_vm.loaderColor,"size":"small","float":""}}):_vm._e()],1),(_vm.leadingIcon)?_c('span',{key:"BBC-leading-icon",class:[
      '_icon _icon-leading',
      ('icon-' + _vm.leadingIcon),
    ]}):_vm._e(),(_vm.$slots.default)?_c('span',{key:"BBC-text-slot",staticClass:"_text"},[_vm._t("default")],2):_vm._e(),(_vm.trailingIcon)?_c('i',{key:"BBC-trailing-icon",class:[
      '_icon _icon-trailing',
      ('icon-' + _vm.trailingIcon),
    ]}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }